import React, { useState } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';
import { Helmet } from 'react-helmet';  // Importera Helmet

function Trappstadning() {

    const [brf, setBrf] = useState('');
  const [kontaktperson, setKontaktperson] = useState('');
  const [email, setEmail] = useState('');
  const [telefon, setTelefon] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null); // för feedback till användaren

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      brf,
      kontaktperson,
      email,
      telefon,
      message,
    };

    fetch('/backend/trapphus-form-handler.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(res => res.json())
      .then(response => {
        setStatus('Förfrågan skickad! Vi återkommer inom 48 timmar.');
        // Rensa formulär om du vill:
        setBrf('');
        setKontaktperson('');
        setEmail('');
        setTelefon('');
        setMessage('');
      })
      .catch(error => {
        setStatus('Något gick fel, försök igen senare.');
        console.error(error);
      });
  };
  return (
    <>
      <Helmet>
        <title>Trappstädning för Rent & Fräscht Trapphus – Provalt Service AB</title>
        <meta name="description" content="Vi tar hand om trapphus och gemensamma utrymmen med regelbunden trappstädning. Säkerställ en ren och trivsam miljö för boende och besökare." />
        <link rel="canonical" href="https://provalt.se/trappstadning" />
      </Helmet>
<section
  className="relative min-h-[500px] md:h-[450px] bg-cover bg-center text-white py-16 px-6 overflow-hidden"
  style={{ backgroundImage: "url('/images/cleaning/trappstadning-provalt.webp')" }}
>
  <div className="absolute inset-0 z-0"></div>

  <div className="relative z-10 max-w-6xl mx-auto text-center bg-black bg-opacity-40 p-5">
    <h1 className="text-2xl md:text-5xl font-bold mb-10 drop-shadow-lg">
      Trappstädning för BRF och Fastighetsägare
    </h1>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 text-left max-w-4xl mx-auto text-lg md:text-xl">
      <ul className="mb-4 space-y-2">
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Professionell & noggrann trappstädning
        </li>
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Miljövänliga metoder
        </li>
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Utbildad personal
        </li>
      </ul>
      <ul className="mb-4 space-y-2">
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Snabb & tydlig offert – inom 48 timmar
        </li>
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Anpassad städutrustning för bästa resultat
        </li>
        <li className="flex items-center">
          <CheckIcon className="w-5 h-5 text-green-500 mr-2" />
          Regelbundna kvalitetskontroller
        </li>
      </ul>
    </div>
  </div>
</section>

      <section className="bg-gray-50 py-20 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-16 text-gray-800">Hur fungerar det?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 text-left">
            
            {[1, 2, 3, 4].map((num) => {
              const titles = [
                "Steg 1 – Fyll i kontaktformulär",
                "Steg 2 – Personlig konsultation",
                "Steg 3 – Offert och planering",
                "Steg 4 – Avtal skrivs på",
              ];

              const descriptions = [
                "Börja med att skicka in en intresseanmälan via formuläret nedan. Ange era behov och önskemål, så kontaktar vi er så snart som möjligt.",
                "Vi ringer upp er för att gå igenom era specifika krav och förväntningar. Vid behov bokar vi in ett besök för att inspektera fastigheten och säkerställa att vi erbjuder den bästa lösningen.",
                "Efter genomgången skickar vi en skräddarsydd offert med ett förslag på upplägg, omfattning och städfrekvens. Vi anpassar tjänsten utifrån era önskemål och behov.",
                "När ni är nöjda med upplägget skriver vi avtal och påbörjar trappstädningen enligt den överenskomna planen. Ni kan känna er trygga med att våra professionella städare levererar hög kvalitet och ett skinande rent resultat.",
              ];

              return (
                <div
                  key={num}
                  className="bg-white rounded-3xl shadow-md p-8 flex items-start gap-6 hover:shadow-xl transition-shadow"
                >
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-600 text-white flex items-center justify-center text-lg font-bold">
                    {num}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800">
                      {titles[num - 1]}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">{descriptions[num - 1]}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="bg-white py-20 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Textdel */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 mb-6">
            Rena och välskötta trapphus – en viktig del av en trivsam fastighet
          </h2>
          <p className="text-gray-700 mb-4">
            Ett välstädat trapphus bidrar inte bara till trivsel och trygghet, utan ger även ett gott intryck för både boende och besökare. Vi förstår att varje fastighet har sina egna behov – därför erbjuder vi skräddarsydda lösningar som matchar just era krav.
          </p>
          <p className="text-gray-700 mb-6">
            Vårt team består av utbildad och erfaren personal som använder miljövänliga rengöringsmetoder och modern utrustning för bästa resultat. Vi jobbar systematiskt och noggrant för att leverera en konstant hög kvalitet – oavsett fastighetens storlek eller skick.
          </p>
          <p className="text-gray-700 mb-6">
            Fyll i formuläret så kontaktar vi er för att gå igenom era behov och ta fram en tydlig offert. Vi återkommer snabbt för en kostnadsfri konsultation – helt utan förpliktelser!
          </p>
          <ul className="text-gray-700 space-y-2">
            <li>✔ Professionell och pålitlig städning</li>
            <li>✔ Anpassade lösningar efter era behov</li>
            <li>✔ Miljövänliga rengöringsmedel</li>
            <li>✔ Regelbundna kvalitetskontroller</li>
            <li>✔ Konkurrenskraftiga priser utan dolda avgifter</li>
          </ul>
        </div>


          {/* Formulärdel */}
          <div className="bg-gray-100 rounded-2xl p-8 shadow-md">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6">
              Fyll i formuläret och få offert inom 48 timmar
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">BRF/Fastighetsägare</label>
                <input
                  type="text"
                  value={brf}
                  onChange={(e) => setBrf(e.target.value)}
                  className="w-full mt-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Kontaktperson</label>
                <input
                  type="text"
                  value={kontaktperson}
                  onChange={(e) => setKontaktperson(e.target.value)}
                  className="w-full mt-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">E-post</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Telefonnummer</label>
                <input
                  type="tel"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                  className="w-full mt-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Meddelande</label>
                <textarea
                  rows="4"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="w-full mt-1 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition"
              >
                Skicka förfrågan
              </button>
              {status && (
                <p className="mt-4 text-green-600 font-semibold">
                  {status}
                </p>
              )}
            </form>

          </div>
        </div>
      </section>
      <section className="bg-gray-100 py-20 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-16">
            6 skäl till att välja Provalt Service AB till er trappstäd
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-left">
            {/* Vänster kolumn */}
            <div className="space-y-10">
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Professionell och pålitlig service</h3>
                  <p className="text-gray-600">
                    Vi har lång erfarenhet av trappstädning och arbetar alltid med noggrannhet och hög kvalitet. Vår personal är utbildad, pålitlig och mån om att skapa en ren och trivsam miljö i er fastighet.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Skräddarsydda lösningar</h3>
                  <p className="text-gray-600">
                    Vi anpassar städningen efter era specifika behov och önskemål. Oavsett om ni vill ha städning flera gånger i veckan eller mer sällan, tar vi fram en lösning som passar just er.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Kvalitetssäkring och miljövänliga produkter</h3>
                  <p className="text-gray-600">
                    Vi använder endast effektiva och miljövänliga rengöringsmedel för att säkerställa ett skinande rent resultat utan att påverka miljön negativt. Vår kvalitetssäkring innebär att vi regelbundet kontrollerar och följer upp vårt arbete.
                  </p>
                </div>
              </div>
            </div>

            {/* Höger kolumn */}
            <div className="space-y-10">
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  4
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Konkurrenskraftiga priser utan dolda avgifter</h3>
                  <p className="text-gray-600">
                    Hos oss får ni alltid transparenta och rimliga priser utan överraskningar. Vi erbjuder kostnadseffektiva lösningar utan att kompromissa på kvaliteten.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  5
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Snabb och smidig kommunikation</h3>
                  <p className="text-gray-600">
                    Vi värdesätter god kundkontakt och finns alltid tillgängliga för frågor, ändringar och uppföljning. Genom en nära dialog säkerställer vi att ni är nöjda med vår tjänst – varje gång!
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-semibold shrink-0">
                  6
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">Trygghet och långsiktiga samarbeten</h3>
                  <p className="text-gray-600">
                    Vi bygger långvariga relationer med våra kunder genom pålitlig service och hög kvalitet. Med fasta rutiner, samma städpersonal och en dedikerad kontaktperson kan ni känna er trygga med att trappstädningen alltid sköts professionellt och konsekvent.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white py-20 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Titel: Grundutbudet */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">
            Grundutbudet
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
            {/* Vänster kolumn */}
            <div className="space-y-10">
              <div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">Trapphus</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  <li>Golv och trappsteg sopas och fukttorkas med mopp</li>
                  <li>Fläckar på väggar och ledstänger torkas av</li>
                  <li>Element, fönsterbrädor och andra detaljer torkas av</li>
                  <li>Dammar av lister</li>
                  <li>Mattor skakas eller dammsugs</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">Entré</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  <li>Golv sopas och fukttorkas</li>
                  <li>Glas i entrédörren putsas</li>
                  <li>Skrapgaller/skrapmatta rengörs</li>
                  <li>Lösa entrémattor skakas och dammsugs</li>
                  <li>Dammtorkning av brevlådor, element, anslagstavla mm.</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">Lokaler</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  <li>Dammsuger eller sopar golv i kök och toalett</li>
                  <li>Dammtorkar alla öppna ytor</li>
                  <li>Moppar av golvet</li>
                  <li>Rengör handfat, toalett och behållare</li>
                  <li>Tömmer och byter papperskorgar</li>
                </ul>
              </div>
            </div>

            {/* Höger kolumn */}
            <div className="space-y-10">
              <div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">Tvättstuga</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  <li>Dammtorkar och rengör tvättmaskiner, torktumlare och torkskåp</li>
                  <li>Rengör vask och ytor</li>
                  <li>Tömmer och rengör luddfilter</li>
                  <li>Byter papperskorg</li>
                  <li>Dammsuger och moppar golvet</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-700 mb-2">Hiss</h3>
                <ul className="list-disc list-inside text-gray-600 space-y-1">
                  <li>Väggar torkas av</li>
                  <li>Golv sopas och fukttorkas</li>
                  <li>Speglar och glas putsas</li>
                  <li>Handtag och fläckar rengörs på alla våningsplan</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Ny sektion: Tilläggstjänster */}
          <div className="mt-10">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">
              Tilläggstjänster
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 text-gray-700">
              <div>
                <h3 className="text-xl font-semibold mb-2">Storstädning</h3>
                <p>
                  Med en storstädning kan vi säkerställa att era lokaler håller en extra hög standard.
                  Vi fokuserar på förråd, tvättstugor och gemensamma utrymmen – eller där ni anser det behövs mest.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Fönsterputs</h3>
                <p>
                  Vi erbjuder regelbunden fönsterputsning med all utrustning som krävs. Ni får rena fönster utan att lyfta ett finger.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Trädgårdsservice</h3>
                <p>
                  Våra trädgårdsexperter sköter gräsklippning, beskärning och plantering – året runt. Innergårdar och uteplatser hålls vackra och välvårdade.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Övriga tjänster</h3>
                <p>
                  Behöver ni hjälp med förbrukningsmaterial, lampbyten eller snöskottning? Vi hjälper gärna till – säg bara till!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>




    </>
  );
}

export default Trappstadning;
